import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { ScrollIcon } from "@phosphor-icons/react";

export default function TermsGate() {
  const { user, setUser } = useAuth();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || user.terms_accepted) return null;

  const gov = !!user?.is_gov;

  const accept = async () => {
    if (!checked) return;
    setBusy(true);
    try {
      await api.post("/me/accept-terms");
      setUser({ ...user, terms_accepted: true });
      toast.success("Thanks — your acceptance has been recorded.");
    } catch (e) {
      toast.error("Could not record acceptance — please try again.");
    }
    setBusy(false);
  };

  return (
    <div data-testid="terms-gate" className="fixed inset-0 z-[80] bg-[#061025]/85 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="w-full max-w-lg rounded-xl border border-zinc-700 bg-[#0A0F1E] shadow-2xl p-6">
        <div className="flex items-center gap-2.5 mb-3">
          <ScrollIcon size={22} weight="duotone" className={gov ? "text-[#7FB0E6]" : "text-signal"} />
          <h2 className="text-lg font-semibold text-zinc-50">Review &amp; accept to continue</h2>
        </div>
        <p className="text-[14px] leading-relaxed text-zinc-300">
          Before using {user?.is_gov ? <>EMBI<span className="text-[#4F84C4]">-Gov</span>&#8480;</> : <>EMBI&#8480; AI Impact</>}, please review and accept our terms. Note in particular that <strong className="text-zinc-100">account sharing and reverse engineering are prohibited</strong>, and workspace data is for the licensed client's internal use only.
        </p>
        <label className="mt-5 flex items-start gap-3 cursor-pointer select-none">
          <input
            data-testid="terms-gate-checkbox"
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className={`mt-0.5 h-4 w-4 shrink-0 ${gov ? "accent-[#4F84C4]" : "accent-signal"}`}
          />
          <span className="text-[13px] text-zinc-300 leading-relaxed">
            I have read and agree to the{" "}
            <a href="/terms" target="_blank" rel="noopener noreferrer" className={`underline decoration-dotted underline-offset-2 ${gov ? "text-[#7FB0E6]" : "text-signal"}`}>Terms &amp; Conditions</a>,{" "}
            <a href="/privacy" target="_blank" rel="noopener noreferrer" className={`underline decoration-dotted underline-offset-2 ${gov ? "text-[#7FB0E6]" : "text-signal"}`}>Privacy Policy</a>, and{" "}
            <a href="/ai-ethics" target="_blank" rel="noopener noreferrer" className={`underline decoration-dotted underline-offset-2 ${gov ? "text-[#7FB0E6]" : "text-signal"}`}>AI Ethics &amp; Safety</a> policies.
          </span>
        </label>
        <button
          data-testid="terms-gate-accept-btn"
          onClick={accept}
          disabled={!checked || busy}
          className={`mt-5 w-full py-2.5 rounded-md text-[14px] font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${gov ? "bg-[#4F84C4] hover:bg-[#3f6ea8] text-white" : "bg-signal hover:bg-signal-dark text-zinc-950"}`}
        >
          {busy ? "Recording…" : "Agree & continue"}
        </button>
      </div>
    </div>
  );
}
